import React, { useLayoutEffect, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { UseTranslationProps } from 'types/UseTranslationProps';
import TitleNavBarContext from 'context/TitleNavBarContext';
import TabsSettingsProps from 'components/TabsSettings';
import { tabsList } from './listTabsflag';
import { TabSettingPageProps } from 'types/TabSettingPageProps';
import GeneralSettings from 'components/GeneralSettings';
import ProvidersSettings from 'components/ProvidersSettings';
import FeatureSettings from 'components/FeatureSettings';
import { CredentialFather } from 'types/ProvidersProps';

export default function Settings() {
	const { i18n }: UseTranslationProps = useTranslation();
	const { setDataAbouTitle } = useContext(TitleNavBarContext);

	const [listTabs, setListTabs] = useState<TabSettingPageProps[]>(tabsList);
	const [optionActive, setOptionActive] = useState(0);
	const [listProviders, setListProviders] = useState<CredentialFather[]>([]);

	// Para colocar na tela o componente desejado
	useLayoutEffect(() => {
		listTabs.forEach((item: TabSettingPageProps) => {
			if (item.isSelected === true) {
				setOptionActive(item.id);
			}
		});
	}, [listTabs]);

	//muda titulo do componente
	useLayoutEffect(() => {
		setDataAbouTitle((value) => ({
			...value,
			title: 'navBarOptions.settings'
		}));
	}, [i18n?.language]);

	return (
		<S.container>
			<TabsSettingsProps setTabsList={setListTabs} tabsList={listTabs} />

			<GeneralSettings isVisiable={optionActive === 0} />

			<ProvidersSettings
				isVisiable={optionActive === 1}
				listProviders={listProviders}
				setListProviders={setListProviders}
			/>

			<FeatureSettings
				isVisiable={optionActive === 2}
				listProviders={listProviders}
				// setListProviders={setListProviders}
			/>
		</S.container>
	);
}
